/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import _ from "lodash";
import Form from "forms/Form";
import formWrapper from "hoc/formWrapper";
import { InlineNotification, Loading, Tag } from "carbon-components-react";
import { consoleLog } from "utils/functions";
import { CHECK_AVAILABILITY, DOMAINS } from "api/config/endpoints";

const CheckDomainAvailabilityForm = ({ onChangeTabClicked, onUpdateDomainName,setIsRegisterDisable, ...props }) => {

    const [saving, setSaving] = useState(false);
    const [errors, setErrors] = useState(); // Future use
    const [report, setReport] = useState();
    const [registrableDomainName, setRegistrableDomainName] = useState();
    const [defaultValues, setDefaultValues] = useState({});
    const [isFqdn, setIsFqdn] = useState();

    useEffect(() => {
        updateIsFqdn(props.defaultValues?.domain_name)
        setDefaultValues(props.defaultValues)
    }, [props.defaultValues])

    const getValue = (name, type) => {
        const value = !_.isEmpty(defaultValues) ? defaultValues[name] : null;
        switch (type) {
            case "bool":
                return (value !== 0 && value !== null && value !== undefined);
            default:
                return value;
        }
    };

    const getEndpoint = () => {
        return [DOMAINS, CHECK_AVAILABILITY].join("/")
    }

    const onSubmit = async (e) => {
        setReport()
        setErrors()
        setRegistrableDomainName()
        consoleLog("client.get onSubmit", e)
        if (e.error) {
            setErrors(e.error)
        }
        if (e.report) {
            setReport(e.report)
        }
        if (e.registrable_domain_name) {
            setRegistrableDomainName(e.registrable_domain_name)
        }
        if (props.onSubmit) {
            props.onSubmit()
        }
    }

    let fields = 1
        ? [
            {
                elementType: "domain",
                id: "domain_name",
                name: "domain_name",
                labelText: `Domain name`,
                value: getValue("domain_name"),
            },
        ]
        : [];

    const onChange = (key, value) => {
        console.log("onChange", key, value)
        if (key === "domain_name") {
            console.log("onChange fqdn", value.match(/^(?!\-)(?:(?:[a-zA-Z\d][a-zA-Z\d\-]{0,61})?[a-zA-Z\d]\.){1,126}(?!\d+)[a-zA-Z\d]{1,63}$/i))
            updateIsFqdn(value)
            onUpdateDomainName(value)
            setReport()
        }
        setDefaultValues({
            ...defaultValues,
            [key]: value
        });
    }

    const updateIsFqdn = (value) => {
        if (!value) {
            setIsFqdn(false)
        }
        else {
            setIsFqdn(value.match(/^(?!\-)(?:(?:[a-zA-Z\d][a-zA-Z\d\-]{0,61})?[a-zA-Z\d]\.){1,126}(?!\d+)[a-zA-Z\d]{1,63}$/i))
        }
    }

    const onSavingChange = (value) => {
        setSaving(value)
    }

    const addToOutput = (output, element) => {
        output.push(<div style={{ margin: "0.25rem" }}>{element}</div>)
        return output
    }

    const changeTab = ({ tabIndex, domainName }) => {
        onChangeTabClicked(tabIndex)
        onUpdateDomainName(domainName)
    }

    let extraContents = [];

    const domainName = getValue("domain_name")

    if (getValue("domain_name")) {
        if (!isFqdn) {
            extraContents.push(
                <Tag type="red">
                    This is not a valid domain name
                </Tag>
            )
        }
        // else if (isFqdn) {
        //     extraContents.push(
        //         <Tag type="green">
        //             This is a valid Fully qualifiied DOMAIN
        //         </Tag>
        //     )
        // }
        console.log("report", report)
        if (report) {
            Object.keys(report)?.forEach(index => {
                const value = report[index]
                const selectedDomainName = domainName
                const decoratedSelectedDomainName = <strong>{domainName}</strong>
                // })}
                // {report?.map((value, index) => {
                let output = []
                let tagColor = "red"
                switch (index) {
                    case "available":
                        if (value) {
                            // Makes available Register Tab
                            setIsRegisterDisable(false)
                            
                            tagColor = "green"
                            output = addToOutput(output, (
                                <>
                                    <InlineNotification
                                        kind="success"
                                        hideCloseButton={true}
                                        lowContrast={true}
                                        title={(<>{decoratedSelectedDomainName} is available!</>)}
                                        subtitle={props.hideRegisterLinkRef ? null : (
                                            <a onClick={() => changeTab({ tabIndex: 1, domainName: selectedDomainName })}>Register {decoratedSelectedDomainName} domain</a>
                                        )}
                                    />
                                </>
                            ))
                        }
                        else {
                            // Disable Register Tab
                            setIsRegisterDisable(true)
                            output = addToOutput(output, (
                                <>
                                    <InlineNotification
                                        kind="error"
                                        hideCloseButton={true}
                                        lowContrast={true}
                                        title={(<>{decoratedSelectedDomainName} is NOT available for registration</>)}
                                    />
                                </>
                            ))
                        }

                        output.unshift(<Tag type={tagColor}>Available</Tag>)
                        break;
                    case "registered_by_adam":
                        if (value) {
                            tagColor = "green"
                            output = addToOutput(output, (
                                <>{decoratedSelectedDomainName} registered by ADaM</>
                            ))
                        }
                        else {
                            output = addToOutput(output, (
                                <>{decoratedSelectedDomainName} is NOT registered by ADaM</>
                            ))
                        }
                        output.unshift(<Tag type={tagColor}>Registered by ADaM</Tag>)
                        break;
                    case "attached_to_amplify":
                        if (value) {
                            tagColor = "green"
                            output = addToOutput(output, (
                                <>
                                    <div>
                                        <InlineNotification
                                            kind="success"
                                            hideCloseButton={true}
                                            lowContrast={true}
                                            title={"Attached to ADaM"}
                                            subtitle={<>{decoratedSelectedDomainName} is attached to ADaM. No further actions are needed</>}
                                        />
                                    </div>
                                </>
                            ))
                        }
                        else {
                            output = addToOutput(output, (
                                <>
                                    <div>
                                        <InlineNotification
                                            kind="error"
                                            hideCloseButton={true}
                                            lowContrast={true}
                                            title={""}
                                            subtitle={<>{decoratedSelectedDomainName} is NOT attached to ADaM</>}
                                        />
                                    </div>
                                    {
                                        report.parent_registered_on_route53 ? (
                                            <div>
                                                <InlineNotification
                                                    kind="info"
                                                    hideCloseButton={true}
                                                    lowContrast={true}
                                                    title="The parent domain is already registered and managed by our AWS account"
                                                    subtitle={props.hideAttachLinkRef ? null : (
                                                        <a onClick={() => changeTab({ tabIndex: 2, domainName: selectedDomainName })}>Attach {decoratedSelectedDomainName} domain to ADaM</a>
                                                    )}
                                                />
                                            </div>

                                        ) : null
                                    }
                                </>

                            ))
                        }
                        break;
                    case "registered_on_route53":
                        if (value) {
                            tagColor = "green"
                            output = addToOutput(output, (
                                <div>
                                    <InlineNotification
                                        kind="success"
                                        hideCloseButton={true}
                                        lowContrast={true}
                                        title={"Hosted by ADaM"}
                                        subtitle={<>{decoratedSelectedDomainName} is hosted by our AWS account</>}
                                    />
                                </div>
                            ))
                        }
                        else {
                            output = addToOutput(output, (
                                <>
                                    <div>{decoratedSelectedDomainName} is NOT hosted by our AWS account</div>
                                    {
                                        report.parent_registered_on_route53 ? (
                                            <div>
                                                {decoratedSelectedDomainName} is a subdomain of <strong>{report.registrable_domain}</strong>. This domain is hosted our AWS account
                                            </div>
                                        ) : null
                                    }
                                </>
                            ))
                        }
                        output.unshift(<Tag type={tagColor}>Hosted by ADaM</Tag>)
                        break;
                    case "is_registrable":
                        if (value) {
                            tagColor = "green"
                            output = addToOutput(output, (
                                <>{decoratedSelectedDomainName} is registrable by our AWS account</>
                            ))
                        }
                        else {
                            if (report?.registrable_domain) {
                                output = addToOutput(output, (
                                    <>
                                        <div>The domain is NOT registrable</div>
                                        <div><a onClick={() => onChange("domain_name", report.registrable_domain)}>Please, verify the related registrable domain {report.registrable_domain}</a></div>
                                    </>
                                ))
                            }
                            else {
                                output = addToOutput(output, (
                                    <>{decoratedSelectedDomainName} is NOT registrable</>
                                ))
                            }
                        }
                        output.unshift(<Tag type={tagColor}>Registrable</Tag>)
                        break;
                    default:
                }
                extraContents.push(
                    <div style={{ marginTop: "1rem" }}>
                        {output}
                    </div>
                )
            })
        }
    }

    if (registrableDomainName && registrableDomainName !== domainName) {
        extraContents.push(
            <div style={{ marginTop: "1rem" }}>
                <InlineNotification
                    kind="warning"
                    hideCloseButton={true}
                    lowContrast={true}
                    title="Probably you are trying to register a subdomain"
                />
            </div>
        )
    }

    // if (errors) {
    //     if (errors.includes("tld is not supported")) {
    //         extraContents.push(
    //             <InlineNotification
    //                 kind="warning"
    //                 hideCloseButton={true}
    //                 lowContrast={true}
    //                 title="Probably you are trying to register a subdomain"
    //             />
    //         )
    //     }
    //     extraContents.push(
    //         <div className="form-error__text">
    //             {errors}
    //         </div>
    //     )
    // }

    return (
        <div className={props.className}>
            {
                saving ? <Loading /> : null
            }
            <Form
                fields={fields}
                extra={fields}
                endpoint={getEndpoint()}
                loaded={true}
                modal={props.modal}
                onRequestClose={props.onRequestClose}
                onSavingChange={(value) => onSavingChange(value)}
                onChange={(key, val) => onChange(key, val)}
                onSubmit={(e) => onSubmit(e)}
                extraContents={props.hideRegisterLinkRef ? null : (
                    <div style={{ marginBottom: "1rem" }}>
                        Please remember:<br />
                        <strong>DO NOT REGISTER SUBDOMAINS!</strong><br />
                        In case of the requested domain for the event is <em>registration.event-domain.com</em> you have to register <em>event-domain.com</em>
                    </div>
                )}
                extraFieldsAfter={extraContents}
                primaryButtonText={"Verify"}
                submitButtonDisabled={!isFqdn}
            />
        </div>
    );
};

export default formWrapper(CheckDomainAvailabilityForm);
